export default "__VITE_ASSET__CRTROlQQ__"